import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Dialog from 'Components/UI/Dialog';
import Button from 'Components/UI/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = theme => ({
  primaryDialogContent: {
    color: theme.palette.facet.primaryBlue,
  },
  secondaryDialogContent: {},
  centeredDialogActions: {
    justifyContent: 'center',
  },
  centeredDialogContent: {
    textAlign: 'center',
  },
});

const ConfirmationDialog = ({
  classes,
  onConfirm,
  onCancel,
  message,
  children,
  title,
  cancelLabel,
  confirmLabel,
  secondaryOnConfirm,
  secondaryMessage,
  secondaryConfirmLabel,
  secondaryConfirmationMessage,
  SecondaryActionComponent,
  ...rest
}) => {
  const [showSecondaryActionConfirmation, setShowSecondaryActionConfirmation] = useState(false);
  return (
    <Dialog maxWidth="xs" onClose={onCancel} open {...rest}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent className={classNames({
        [classes.primaryDialogContent]: !!secondaryOnConfirm,
        [classes.centeredDialogContent]: !!secondaryOnConfirm,
      })}
      >
        <Typography variant="body1">{message}</Typography>
        {children}
      </DialogContent>
      <DialogActions className={classNames({
        [classes.centeredDialogActions]: !!secondaryOnConfirm,
      })}
      >
        <Button color="primary" variant="text" onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button
          color="primary"
          disableElevation
          variant="contained"
          onClick={onConfirm}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
      {secondaryOnConfirm && (
        <>
          <DialogContent className={classNames({
            [classes.centeredDialogContent]: !!secondaryOnConfirm,
          })}
          >
            <Typography variant="body1">{secondaryMessage}</Typography>
          </DialogContent>
          <DialogActions className={classNames(classes.secondaryDialogContent, {
            [classes.centeredDialogActions]: !!secondaryOnConfirm,
          })}
          >
            {SecondaryActionComponent
              ? <SecondaryActionComponent onClick={secondaryConfirmationMessage ? () => setShowSecondaryActionConfirmation(true) : secondaryOnConfirm} />
              : (
                <Button
                  color="primary"
                  disableElevation
                  variant="contained"
                  onClick={secondaryOnConfirm}
                >
                  {secondaryConfirmLabel}
                </Button>
              )}
          </DialogActions>
        </>
      )}
      {showSecondaryActionConfirmation && (
        <ConfirmationDialog
          classes={styles}
          message={secondaryConfirmationMessage}
          onConfirm={() => {
            setShowSecondaryActionConfirmation(false);
            secondaryOnConfirm();
          }}
          onCancel={() => setShowSecondaryActionConfirmation(false)}
        />
      )}
    </Dialog>
  );
};

ConfirmationDialog.propTypes = {
  children: PropTypes.node,
  message: PropTypes.string.isRequired,
  title: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  secondaryOnConfirm: PropTypes.func,
  secondaryMessage: PropTypes.string,
  secondaryConfirmLabel: PropTypes.string,
  secondaryConfirmationMessage: PropTypes.string,
  SecondaryActionComponent: PropTypes.node,
};

ConfirmationDialog.defaultProps = {
  cancelLabel: 'Cancel',
  children: null,
  confirmLabel: 'Yes',
  title: 'Are you sure?',
  secondaryOnConfirm: null,
  secondaryMessage: '',
  secondaryConfirmLabel: '',
  secondaryConfirmationMessage: '',
  SecondaryActionComponent: null,
};

export default withStyles(styles, { name: 'ConfirmationDialog' })(ConfirmationDialog);
